import React, { useState, useEffect, useMemo } from "react";
import { useSetLoading } from "../../../../common/hooks/appearance";
import { MUITable } from "../../../../common/components";
import { BreadcrumbComponent } from "../../../../common/components";
import "../lead-assignment.scss";
import { routes } from "../../../../constants/routes";
import { PaginationComponent } from "../../../../common/components";
import { getLeadAssignmentHistory } from "../../../../api/lead-assignment";
import { useLocation } from "react-router-dom";
import { formatDateTime } from "../../../../utils/utils";
import LeadsStatus from "../../leads-status";

const Leads = () => {
  const breadcrumbLink = [
    { label: "Lead Assignment", link: `${routes.ASSIGNMENTRULES}` },
    { label: "Assignment Rules", link: `${routes.ASSIGNMENTRULES}` },
    { label: "Leads", link: "#", handleClick: () => {} },
  ];

  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [pageSize] = useState<number>(15);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const location = useLocation();
  const ruleId = location.state?.id;

  const fetchAssignLeads = async (ruleId: number, page = 1) => {
    setLoading(true);
    const offset = (page - 1) * pageSize;
    const params = {
      limit: pageSize,
      offset,
    };

    try {
      const response = await getLeadAssignmentHistory(ruleId, params);
      setData(response.data.data?.assignedLeads);
      setTotalRecords(response.data.data.totalassignedLeads);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };
  const headers = [
    { key: "leadName", label: "Lead Name", isSortable: false },
    { key: "assignedPartner", label: "Assigned Partner", isSortable: false },
    {
      key: "assignedDateAndTime",
      label: "Assigned Date & Time",
      isSortable: false,
    },
    { key: "status", label: "Status", isSortable: false },
  ];

  const fetchFullName = (lead: any) => {
    const firstName = lead?.first_name?.trim() || "";
    const middleName = lead?.middle_name?.trim() || "";
    const lastName = lead?.last_name?.trim() || "";

    const fullName = [firstName, middleName, lastName]
      .filter(Boolean)
      .join(" ");
    return fullName || "-";
  };
  const formattedData = useMemo(() => {
    if (Array.isArray(data)) {
      return data.map((item: any) => {
        const leadName = fetchFullName(item.lead);
        return {
          id: item.id,
          leadName,
          assignedPartner: item?.assignedPartner?.company_name || "-",
          assignedDateAndTime: formatDateTime(item?.assigned_at) || "-",
          status: item?.lead?.lead_status || "-",
        };
      });
    }
    return [];
  }, [data]);

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setCurrentPage(value);
  };

  const showLoading = useMemo(() => loading, [loading]);
  useSetLoading(showLoading);

  useEffect(() => {
    if (ruleId) {
      fetchAssignLeads(Number(ruleId), currentPage);
    }
  }, [ruleId, currentPage]);

  const noResultsTxt = useMemo(() => {
      if (loading) {
      return "Loading Leads...";
    }
    return "No Leads found";
  }, [loading]);

  return (
    <>
      <div className="leadlist-wrapper assignment-rules-leads-wrapper">
        <div className="breadcrumb-wrapper">
          <BreadcrumbComponent breadcrumbLink={breadcrumbLink} />
        </div>
        <span className="rule-title"><strong>Rule:</strong>{` ${data[0] ? data[0]?.assignmentRule?.rule_name : ''}`}</span>
        <div className="lead-list-table assignment-rules-leads-list-table">
          <MUITable
            headers={headers}
            data={formattedData.map((item: any) => ({
              leadName: item.leadName,
              assignedPartner: item?.assignedPartner,
              assignedDateAndTime: item?.assignedDateAndTime,
              status: <LeadsStatus status={item?.status} />,
            }))}
            noResultsTxt={noResultsTxt}
          />
        </div>
        {totalRecords > 0 && (
          <div className="leads-pagination-container">
            <PaginationComponent
              totalRecords={totalRecords}
              pageSize={pageSize}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default Leads;
